/**
 * CommonConstants
 */

const CommonConstants = {
  assets: {
    logo: require("../assets/gdol.png"),
    logoWhite: require("../assets/gdol-white.png"),
    iso: require("../assets/iso-branco.png"),
    noAvatar: require("../assets/no-avatar.jpg"),
  },
  pageIds: {
    funcionario: 0,
  },
  avaliarTreinamentoScreen: {
    FuncionarioCadastro: 55,
    GestaoTreinamentosCadastro: 3138,
  },
  cacheKey: {
    centroCustoDropDown: "centro-custo-dropdown",
    treinamentosDropDown: "treinamentos-dropdown",
    clientesDropDown: "cliente-dropdown",
    cargoDropDown: "cargo-dropdown",
    setoresDropDown: "setores-dropdown",
    nomesDropDown: "nomes-dropdown",
    filiaisDropDown: "filiais-dropdown",
    habilidadesDropDown: "habilidades-dropdown",
    funcionariosDropDown: "funcionarios-dropdown",
    itensVerbaDropDown: "itens-verba-dropdown",
    equipamentosDropDown: "equipamentos-dropdown",
    motivoAfastamentoDropDown: "motivo-afastamento-dropdown",
    motivoDemissaoDropDown: "motivo-demissao-dropdown",
    funcionarioAssinaturasDropDown: "funcionario-assinaturas-dropdown",
    subContasDropDown: "sub-contas-dropdown",
    folhaPagamentoDropDown: "folha-pagamento-dropdown",
    folhaPagamentoDetalhasDropDown: "folha-pagamento-detalhadas-dropdown",
    bancoPagamentoDropDown: "banco-pagamento-dropdown",
    empreendimentoDropDown: "empreendimento-dropdown",
    incorporacaoBlocoDropDown: "incorporacao-bloco-dropdown",
    obraEstruturaOrganizacionalDropDown: "obra-estrutura-organizacional-dropdown",
    atividadeObraResponsavelDropDown: "atividade-obra-responsavel-dropdown",
    atividadeObraCorresponsavelDropDown: "atividade-obra-corresponsavel-dropdown",
    indicadoresDropDown: "indicadores-dropdown",
    fornecedoresDropDown: "fornecedores-dropdown",
    obraAreaDropDown: "obra-area-dropdown",
    obraServicoDropDown: "obra-servico-dropdown",
    bancosPagamentoDropDown: "bancos-pagamento-dropdown",
    ordemComprasDropDown: "ordem-compras-dropdown",
    usuariosDropDown: "usuarios-dropdown",
    funcionariosTercDropDown: "funcionarios-terc-dropdown",
    monitoramentoChecklistEmpresaDropDown: "monitoramento-checklist-empresa-dropdown",
    monitoramentoChecklistFuncionarioDropDown: "monitoramento-checklist-funcionario-dropdown",
    produtosServicosDropDown: "produtos-servicos-dropdown",
    requisicaoCompraDropDown: "requisicao-compra-dropdown",
    coletaPrecoDropDown: "coleta-preco-dropdown",
    clienteCentroCustoDropDown: "cliente-centro-custo-dropdown",
  },
  moduloDocumentos: {
    Comercial: 0,
    Compras: 1,
    Projeto: 2,
    Rh: 3,
    Auditoria: 4,
    Obras: 5,
    Qualidade: 6,
    Financeiro: 7,
    Externo: 8,
    Interno: 9,
    EquipMedicao: 10,
    MaquinaEquip: 11,
    EntregaObras: 12,
    Terceirizacao: 13,
    Biblioteca: 14,
  },
  obrasActions: {
    informacoesGerais: 1,
    gestaoServicos: 2,
    mapaConcretagem: 3,
    equipamentoMedicao: 4,
    checklistArea: 5,
    equipamentoCritico: 6,
    treinamentos: 7,
    gestaoResiduos: 8,
    alvenariaEstrutural: 9,
    relacaoMateriaisControlados: 10,
    relacaoServicosControlados: 11,
    sustentabilidade: 12,
    documentos: 13,
  },
  successNotificationTime: 1500,
  warningNotificationTime: 2500,
  notificationTime: 4500,
  checkNotificationTimeInSeconds: 3 * 60, // 3 minutos
};

export default CommonConstants;
